import { render, staticRenderFns } from "./InputfieldButton.vue?vue&type=template&id=0471ba84&"
import script from "./InputfieldButton.vue?vue&type=script&lang=js&"
export * from "./InputfieldButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports